import { DateTime, TimeZone } from 'timezonecomplete';

import { MILLIS_IN_WEEK } from '@/config/variables';

/**
 * Returns weekId for given timezone and utcMillis.
 * When the utcMillis are not passed, the returned weekId is for current time
 */
const getWeekIdByMillis = (timeZone: string, utcMillis = Date.now()): number => {
  const currentDay = new DateTime(utcMillis, TimeZone.utc()).convert(TimeZone.zone(timeZone));
  const millisDiff = currentDay.diff(new DateTime(0, TimeZone.utc()).convert(TimeZone.zone(timeZone))).milliseconds();
  return Math.ceil(millisDiff / MILLIS_IN_WEEK);
};

/**
 * Changes timezone of given date in any of the following form: date, date string or utc milliseconds to native Date object.
 * @example
 * // result: date.toISOString() is '2022-12-05T10:46:32.000Z'
 * const date = changeTimeZone('2022-12-05T16:46:32.371Z', 'America/New_York');
 * */
function changeTimeZone(utcMillis: number, timeZone?: string): Date;
function changeTimeZone(dateString: string, timeZone?: string): Date;
function changeTimeZone(date: Date, timeZone?: string): Date;

function changeTimeZone(date: Date | string | number, timeZone?: string): Date {
  const dateToChange = typeof date === 'string' || typeof date === 'number' ? new Date(date) : date;

  return new Date(
    dateToChange.toLocaleString('en-US', {
      timeZone,
    }),
  );
}

export { getWeekIdByMillis, changeTimeZone };
